import type {ReactElement} from 'react';
import React from 'react';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';
import type {RGBA} from '@Utils/color.util';
import {BaseMultiplyColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-multiply-color-panel';

export function SlideitemMutliplyColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const multiplyColor = useGetKeyFromEffectsOfActiveSlideItem('multiplyColor');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (!multiplyColor) {
    throw new Error('multiplyColor property is undefined for active slide item');
  }

  const onUpdateMultiplyColor = (multiplyColor: RGBA, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        effects: {
          multiplyColor,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseMultiplyColorPanel multiplyColor={multiplyColor} onUpdateMultiplyColor={onUpdateMultiplyColor} />;
}
